module.exports = __webpack_public_path__ + "img/van.f69d7b9b.jpg";